import UserRoleBadge from 'components/toolbar/UserRoleBadge';
import type { UserType } from '@econtractor/types';

interface UserRoleItemProps {
    user: UserType;
}

const UserRoleItem = ({ user }: UserRoleItemProps) => {
    const role = user.access?.role;
    if (role !== 'manager' && role !== 'executor' && role !== 'seller') {
        return <span className="text-muted">—</span>;
    }

    return <UserRoleBadge role={role} />;
};

export default UserRoleItem;
